const UserStatus = {
    USER_REGISTERED : 'REGISTERED',
    USER_ACTIVE : 'ACTIVE',
    USER_SUSPENDED : 'SUSPENDED',
    USER_BLOCKED : 'BLOCKED',
}

export default UserStatus